export default "__VITE_ASSET__Demp1jfz__"